/* eslint-disable no-cond-assign */
/*
 * https://gist.github.com/eligrey/1276030
 * insertAdjacentHTML.js
 *   Cross-browser full HTMLElement.insertAdjacentHTML implementation.
 *
 * 2011-10-10
 *
 * By Eli Grey, http://eligrey.com
 * Public Domain.
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 */
import 'innersvg-polyfill';

if (!SVGElement.prototype.insertAdjacentHTML) {
    Object.defineProperty(SVGElement.prototype, 'insertAdjacentHTML', {
        get() {
            return (position, html) => {
                const container = this.ownerDocument.createElementNS(
                    'http://www.w3.org/2000/svg',
                    'svg'
                );
                const parent = this.parentNode;
                let node;
                let firstChild;
                let nextSibling;

                container.innerHTML = html;

                switch (position.toLowerCase()) {
                    case 'beforebegin':
                        while ((node = container.firstChild)) {
                            parent.insertBefore(node, this);
                        }
                        break;
                    case 'afterbegin':
                        firstChild = this.firstChild;
                        while ((node = container.lastChild)) {
                            firstChild = this.insertBefore(node, firstChild);
                        }
                        break;
                    case 'beforeend':
                        while ((node = container.firstChild)) {
                            this.appendChild(node);
                        }
                        break;
                    case 'afterend':
                        nextSibling = this.nextSibling;
                        while ((node = container.lastChild)) {
                            nextSibling = parent.insertBefore(node, nextSibling);
                        }
                        break;
                    default:
                        // eslint-disable-next-line no-console
                        console.warn(
                            `UnexpectedPosition "${position}" for "insertAdjacentHTML" method`
                        );
                        break;
                }
            };
        },
    });
}
